var map = {
	"./menu-ico00.png": 7888,
	"./menu-ico01.png": 2089,
	"./menu-ico02.png": 7554,
	"./menu-ico03.png": 9099,
	"./menu-ico04.png": 4292,
	"./menu-ico05.png": 7533,
	"./menu-ico06.png": 2118,
	"./menu-ico07.png": 9567,
	"./menu-ico08.png": 2504,
	"./menu-ico09.png": 897,
	"./menu-ico10.png": 5787
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1839;